import {DeliveryZoneSummary, YandexDeliverySummary} from "../helpers/yandexDeliveryDetails";
import {IOrder} from "../../models/orders/order";
import React, {useState} from "react";
import {Button} from "antd";
import {EditOutlined, CloseCircleOutlined, CheckCircleOutlined, InboxOutlined, RollbackOutlined, WalletOutlined, StopOutlined} from "@ant-design/icons";
import {YandexDeliveryControls} from "../modal/yandexDelivery";
import {useGlobalContext, useUserContext} from "../../hooks/globalContext";
import {useActions} from "migration/shared/lib/hooks/useActions";
import {CURRENCY} from "../../utils/options/options";
import moment from "moment";
import {Link, useNavigate} from "react-router-dom";
import {addNotificationWithButton} from "../../utils/toast/toast";
import {OrderPaymentStatus} from "./orderPaymentStatus";
import {RouteNames} from "../../migration/pages";

interface IOrderItem {
    order: IOrder
    setView: React.Dispatch<React.SetStateAction<{ order: IOrder | null, active: boolean }>>
    setOrders: React.Dispatch<React.SetStateAction<IOrder[] | null>>
    mode?: 'active' | 'archived'
    trigger?: boolean
    setTrigger?: React.Dispatch<React.SetStateAction<boolean>>
}


export function OrderItem(props: IOrderItem) {
    const {i18n, api} = useGlobalContext()
    const {menu, user, currentMenuId} = useUserContext()
    const navigate = useNavigate()
    const {retryRkeeperOrder} = useActions()

    const mode = props.mode ?? 'active'

    const [cancelApproveLoading, setCancelApproveLoading] = useState<boolean>(false)
    const [setOrderStatusLoading, setSetOrderStatusLoading] = useState<boolean>(false)
    const [retryRkeeperLoading, setRetryRkeeperLoading] = useState<boolean>(false)

    const handleRetryRkeeperOrder = async () => {
        setRetryRkeeperLoading(true)
        await retryRkeeperOrder({
            menuId: currentMenuId,
            orderId: props.order.id,
            organizationId: user?.org?.id || ""
        }, {navigate})
        setRetryRkeeperLoading(false)
        props.setTrigger?.(t => !t)
    }


    function onCancelOrder(id: string) {
        api.CancelOrder({setLoading: setCancelApproveLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.map((order) => {
                    if (order.id === id) {
                        return {...order, currentStatus: "cancelled"}
                    }
                    return order
                }) : null)
            }
        })
    }

    function onApproveOrder(id: string) {
        api.approveOrder({setLoading: setCancelApproveLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.map((order) => {
                    if (order.id === id) {
                        return {...order, currentStatus: ""}
                    }
                    return order
                }) : null)
            }
        })
    }

    function onSetOrderStatusApproved(id: string) {
        api.SetManuallyPaymentStatusApproved({setLoading: setSetOrderStatusLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.map((order) => {
                    if (order.id === id) {
                        return {
                            ...order,
                            payment: order.payment ? {...order.payment, isStatusSetManually: true, status: "approved"} :
                                {isStatusSetManually: true, status: "approved", method: "", completedAt: null}
                        }
                    }
                    return order
                }) : null)
            }
        })
    }

    function onArchiveOrder(id: string) {
        api.archiveOrder({setLoading: setCancelApproveLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.filter((order) => order.id !== id) : null)
            }
        })
    }

    function onUnarchiveOrder(id: string) {
        api.unarchiveOrder({setLoading: setCancelApproveLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.filter((order) => order.id !== id) : null)
            }
        })
    }

    function onSetOrderStatusCancelled(id: string) {
        api.SetManuallyPaymentStatusCancelled({setLoading: setSetOrderStatusLoading}, currentMenuId, id).then((res) => {
            if (res.success) {
                props.setOrders((orders) => orders ? orders.map((order) => {
                    if (order.id === id) {
                        return {
                            ...order,
                            payment: order.payment ? {
                                    ...order.payment,
                                    isStatusSetManually: true,
                                    status: "cancelled"
                                } :
                                {isStatusSetManually: true, status: "cancelled", method: "", completedAt: null}
                        }
                    }
                    return order
                }) : null)
            }
        })
    }

    return (
        <tr key={props.order.id}
            className={props.order.currentStatus === "cancelled" ? "hidden-item" : ""}>
            <td data-title="№">
                <a href="#/"
                   onClick={() => {
                       props.setView({
                           order: props.order,
                           active: true
                       })
                   }}
                >
                    {props.order.number}
                </a>

            </td>
            <td data-title={i18n.customer()}>
                <span className="text-secondary">{props.order.customerContacts.name}</span><br/>
                <span className="">{props.order.customerContacts.phone.number}</span>
            </td>
            <td data-title={i18n.order_content()}
                className="lg-text-right">
                {
                    props.order.items.map((item, index) => {
                        return (
                            <div style={{display: "flex", justifyContent: "space-between"}}
                                 key={props.order.id + "-" + index.toString()}>
                                <span>{(item.name || {})[menu.i18n.defaultLang]} {item.variant.label ?
                                    item.variant.label[menu.i18n.defaultLang] ?
                                        `(${item.variant.label[menu.i18n.defaultLang]})` : null : null
                                }</span>
                                <span>x {item.quantity}</span>
                            </div>

                        )
                    })
                }
                {props.order.orderSupItems?.map((item, index) => {
                    return (
                        <div key={`${item.id}-${index}-${props.order.iiko?.order.externalNumber}`}>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                <div>
                                    <span>{item.name[menu.i18n.defaultLang]} </span>
                                </div>
                                <span>x {item.quantity}</span></div>
                        </div>
                    )
                })}
                <br/>
                <span
                    className="font-weight-bold">{Math.ceil(props.order.totalPrice / 100)} {CURRENCY[props.order.currency]} </span>
            </td>
            <td data-title={i18n.delivery_type()}>

                {props.order.delivery.type === "yandex" && <YandexDeliverySummary order={props.order}/>}
                {props.order.delivery.type === "selfPickupEmpty" ? i18n.self_pickup() : null}
                {props.order.delivery.type === "customPlace" ? <>
                    {i18n.at_place()}
                    <div
                        className={'text-secondary'}>{`${props.order.delivery.data?.label
                        ? props.order.delivery.data.label[menu.i18n.defaultLang] || i18n.table_number()
                        : i18n.table_number()}: ${props.order.delivery.data?.value || i18n.empty()}`}
                    </div>
                </> : null}
                {props.order.delivery.type === "city" ? <>
                    {i18n.delivery()}
                    <div className={'text-secondary'}>{props.order.delivery.data?.address}</div>
                    <div className={'text-secondary'}>{props.order.delivery.data?.detailedAddress}</div>
                    <DeliveryZoneSummary order={props.order}/>
                </> : null}
                {props.order.delivery.type === "placements" ?
                    <>
                        {i18n.in_door_list()}
                        <div
                            className={'text-secondary'}>
                            {`${(props.order.delivery.data?.label || {})[menu.i18n.defaultLang] || i18n.table_number()}: ${(props.order.delivery.data?.name || {})[menu.i18n.defaultLang] || i18n.empty()}`}
                        </div>

                    </>
                    : null}
                {props.order.delivery.type === "cinema" ?
                    <>
                        {i18n.delivery_in_cinema_hall()}
                        <div
                            className={'text-secondary'}>{`${i18n.cinema_hall_number()}: ${props.order.delivery.data?.cinemaHallNumber}`}</div>
                        <div
                            className={'text-secondary'}>{`${i18n.row_number()}: ${props.order.delivery.data?.rowNumber}`}</div>
                        <div
                            className={'text-secondary'}>{`${i18n.seat_number()}: ${props.order.delivery.data?.seatNumber}`}</div>
                    </>
                    : null}
                {props.order.delivery.data?.deliveryComment && props.order.delivery.data?.deliveryComment.length > 0 ?
                    <>
                        <div className="tx-gray">{i18n.delivery_comment()}:</div>
                        <div>{props.order.delivery.data?.deliveryComment}</div>
                    </>
                    : null}
                {props.order.customerComment && props.order.customerComment.length > 0 ?
                    <>
                        <div className="tx-gray">{i18n.customerComment()}:</div>
                        <div>{props.order?.customerComment}</div>
                    </>
                    : null}
            </td>

            <td data-title={i18n.url_parameters()} style={{maxWidth: "400px"}}>

                {Object.keys(props.order.originURLParams || {}).map((key) => {
                    return (
                        <div style={{width: "100%", wordBreak: "break-all",}}>
                            <span style={{color: "orange"}}>{key}</span>
                            <span>{`=${props.order.originURLParams?.[key]}`}</span>
                        </div>
                    )
                })}

            </td>

            <td data-title={i18n.date()}>

                <span className="calendar">{moment(props.order.createdAt).format("DD.MM.YYYY HH:mm")}</span>

            </td>

            {user?.org?.availableModules?.includes("payments") ?
                <td data-title={i18n.status()}>
                    <OrderPaymentStatus payment={props.order.payment} i18n={i18n}/>

                </td>
                : null}

            {user?.org?.availableModules?.includes("iiko") ?
                <td data-title={i18n.iiko_creation_status()}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        {props.order.iikoStatus === "DONE" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#1b9956"}}>{i18n.iiko_creation_status_success()}
                        </span>}
                        {props.order.iikoStatus === "ERROR" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#ff4136"}}>{i18n.iiko_creation_status_error()}
                        </span>}
                        {props.order.iikoStatus === "IN_PROGRESS" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#f2cc56"}}>{i18n.iiko_creation_status_in_progress()}
                        </span>}
                    </div>
                </td>
                : null}

            {user?.org?.availableModules?.includes("rkeeper") ?
                <td data-title={i18n.rkeeper_creation_status()}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        {props.order.rkeeperStatus === "DONE" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#1b9956"}}>{i18n.rkeeper_creation_status_success()}
                        </span>}
                        {props.order.rkeeperStatus === "ERROR" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#ff4136"}}
                            title={props.order.rkeeperOrderTask?.error || undefined}>{i18n.rkeeper_creation_status_error()}
                        </span>}
                        {props.order.rkeeperStatus === "IN_PROGRESS" && <span
                            className={'tags__payment'}
                            style={{backgroundColor: "#f2cc56"}}>{i18n.rkeeper_creation_status_in_progress()}
                        </span>}
                    </div>
                    {props.order.rkeeperStatus === "ERROR" && mode === 'active' && (
                        <Button
                            size="small"
                            style={{marginTop: "6px"}}
                            onClick={handleRetryRkeeperOrder}
                            loading={retryRkeeperLoading}
                            disabled={retryRkeeperLoading}
                        >
                            {i18n.retry_rkeeper_order()}
                        </Button>
                    )}
                </td>
                : null}

            <td data-title={i18n.actions()} className={props.order.delivery.type === "yandex" ? "yandex-order-actions" : undefined}>
                <div className="order-actions">
                    <div className="order-actions__row" role="group" aria-label="Действия с заказом ресторана">
                        <span className="order-actions__label">Заказ</span>
                        <div className="order-actions__buttons">
                            {mode === 'archived' ? (
                                <button type="button" className="default-table__button order-action-button"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            addNotificationWithButton({
                                                message: i18n.q_unarchive_order(),
                                                onSubmit: () => onUnarchiveOrder(props.order.id),
                                                loading: cancelApproveLoading,
                                                i18n
                                            })
                                        }}
                                        title={i18n.q_unarchive_order()} aria-label={i18n.q_unarchive_order()}
                                >
                                    <RollbackOutlined/>
                                </button>
                            ) : (
                                <>
                                    {!user?.org?.availableModules?.includes("iiko") && !user?.org?.availableModules?.includes("rkeeper") &&
                                        <Link to={RouteNames.ORDERS_EDIT.replace(":id", props.order.id)}
                                           className="default-table__button order-action-button"
                                           title={i18n.edit()} aria-label={i18n.edit()}>
                                        <EditOutlined/>
                                    </Link>
                                    }

                                    <button type="button" className="default-table__button order-action-button"
                                            style={{display: props.order.currentStatus === "cancelled" ? "none" : undefined}}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                addNotificationWithButton({
                                                        message: i18n.q_cancel_order(),
                                                        onSubmit: () => onCancelOrder(props.order.id),
                                                        loading: cancelApproveLoading,
                                                        i18n
                                                    }
                                                )
                                            }}
                                            title="Отменить заказ ресторана" aria-label="Отменить заказ ресторана">
                                        <CloseCircleOutlined/>
                                    </button>

                                    <button type="button"
                                            style={{display: props.order.currentStatus !== "cancelled" ? "none" : undefined}}
                                            className="default-table__button order-action-button"
                                            title={i18n.q_recover_order()} aria-label={i18n.q_recover_order()}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                addNotificationWithButton({
                                                    message: i18n.q_recover_order(),
                                                    onSubmit: () => onApproveOrder(props.order.id),
                                                    loading: cancelApproveLoading,
                                                    i18n
                                                })
                                            }}
                                    >
                                        <CheckCircleOutlined/>
                                    </button>

                                    <button type="button" className="default-table__button order-action-button"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                addNotificationWithButton({
                                                    message: i18n.q_archive_order(),
                                                    onSubmit: () => onArchiveOrder(props.order.id),
                                                    loading: cancelApproveLoading,
                                                    i18n
                                                })
                                            }}
                                            title={i18n.q_archive_order()} aria-label={i18n.q_archive_order()}
                                    >
                                        <InboxOutlined/>
                                    </button>

                                    {props.order.payment?.status && user?.org?.availableModules?.includes("payments") ?
                                        <>
                                            {props.order.payment.status !== "approved" ?
                                                <button type="button"
                                                        className="default-table__button order-action-button"
                                                        title={i18n.q_approve_order_payment()}
                                                        aria-label={i18n.q_approve_order_payment()}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            addNotificationWithButton({
                                                                message: i18n.q_approve_order_payment(),
                                                                onSubmit: () => onSetOrderStatusApproved(props.order.id),
                                                                loading: setOrderStatusLoading,
                                                                i18n
                                                            })
                                                        }}
                                                >
                                                    <WalletOutlined/>
                                                </button>
                                                :
                                                <button type="button"
                                                        className="default-table__button order-action-button"
                                                        title={i18n.q_cancel_order_payment()}
                                                        aria-label={i18n.q_cancel_order_payment()}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            addNotificationWithButton({
                                                                message: i18n.q_cancel_order_payment(),
                                                                onSubmit: () => onSetOrderStatusCancelled(props.order.id),
                                                                loading: setOrderStatusLoading,
                                                                i18n
                                                            })
                                                        }}
                                                >
                                                    <StopOutlined/>
                                                </button>
                                            }
                                        </>
                                        : null}
                                </>
                            )}
                        </div>
                    </div>
                    {props.order.delivery.type === "yandex" && <YandexDeliveryControls dispatchInfo={props.order.yandexDispatch} orderId={props.order.id} number={props.order.number}/>}
                </div>
            </td>

        </tr>
    )
}
